import React from 'react';
import {useNavigate} from "react-router-dom";
import {Button} from "../../../../../common/button";
import {PATH} from "../../../../../const/path";
import {useCreateTeacherForm} from "../hook/useCreateTeacherForm";

const ActionFormBrnList = () => {
  const navigate = useNavigate()
    const {canConfirmForm, actionList} = useCreateTeacherForm()
  return (
    <div style={{textAlign: 'right', height: 60}}>
      <Button appearance="ghost"
              onClick={() => navigate(PATH.TEACHER)}
              style={{width: 74}}
      >
          Hủy
      </Button>
      <Button
        onClick={() => actionList.onSave()}
        style={{marginLeft: 12, padding: '0 16px', width: 108}}
        disabled={canConfirmForm.length >= 1}
      >
          Lưu
      </Button>
      {/*{!!value.loading && <Loading/>}*/}
    </div>
  )
}

export default ActionFormBrnList;